import { useRef, useState, useEffect } from 'react';
import { Form, InputGroup } from 'react-bootstrap';
import PropTypes from 'prop-types';
import { AiOutlineCalendar } from 'react-icons/ai';
import './CustomDateInput.scss';
import { Button } from 'ypf-pas-general-ui-components';

const CustomDateInput = ({
  value,
  name,
  isInvalid,
  label,
  disabled,
  placeholder,
  className,
  heightDateInput,
  widthDateInput,
  onClick
}) => {
  const dateInput = useRef();
  const [formatValue, setFormatValue] = useState('');

  useEffect(() => {
    setFormatValue(value ? value.split('T')[0].split('-').reverse().join('/') : null);
  }, [value]);

  return (
    <div className={`styleInput ${className}`}>
      {label && <Form.Label>{label}</Form.Label>}
      <InputGroup
        className="container-input custom-date-input mb-3"
        hasValidation
        style={{ width: widthDateInput }}
      >
        <Form.Control
          autoComplete="off"
          defaultValue={formatValue}
          disabled={disabled}
          isInvalid={isInvalid}
          name={name}
          placeholder={placeholder}
          readOnly
          ref={dateInput}
          style={{ height: heightDateInput }}
          type="text"
        />
        {!disabled && (
          <>
            <Button
              className="icon-style"
              icon={AiOutlineCalendar}
              onClick={onClick}
              sizeIcon="20px"
              type="button"
              widthButton="40px"
            />
          </>
        )}
      </InputGroup>
    </div>
  );
};

CustomDateInput.propTypes = {
  value: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  onClick: PropTypes.func,
  disabled: PropTypes.bool,
  isInvalid: PropTypes.bool,
  label: PropTypes.string,
  placeholder: PropTypes.string,
  className: PropTypes.string,
  heightDateInput: PropTypes.string,
  widthDateInput: PropTypes.string
};

CustomDateInput.defaultProps = {
  disabled: false,
  isInvalid: false,
  onClick: () => {},
  label: '',
  placeholder: '',
  className: '',
  heightDateInput: '',
  widthDateInput: ''
};

export default CustomDateInput;
